import { Routes, Route, BrowserRouter, Navigate, Outlet } from "react-router-dom";
import { MantineProvider, AppShell } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";

import { Navbar } from "./tools/Navbar";
import { Notifications } from "@mantine/notifications";
import MyMarket from "./route/MyMarket";
import MyOS from "./route/MyOS";
import MarketDisplay from "./route/MarketDisplay";
import CreateOS from "./route/CreateOS";
import { UserProvider, useUser } from "./tools/Context";
import Login from "./route/Login";
import Header from "./tools/Header";
import Footer from "./tools/Footer";
import UserManagement from "./route/UserManagement";
import ExportOsData from "./route/ExportOsData";
import NewDecompte from "./route/NewDecompte";
import MyDecompte from "./route/MyDecompte";
import ResetPassword from "./route/ResetPassword";
import ImportData from "./route/ImportData";

function ProtectedLayout() {
  return (
    <AppShell navbar={{ width: 310, breakpoint: "sm" }} header={{ height: 60 }} footer={{ height: 60 }} padding="md">
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Navbar style={{ display: "flex", justifyContent: "space-between" }} p="md">
        <Navbar />
      </AppShell.Navbar>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
      <AppShell.Footer p="md">
        <Footer />
      </AppShell.Footer>
    </AppShell>
  );
}

function Routing() {
  const user = useUser();
  const connected = user.token !== "";

  return (
    <BrowserRouter>
      <MantineProvider defaultColorScheme="light">
        <Notifications />

        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* Protected area */}
          <Route element={connected ? <ProtectedLayout /> : <Navigate to="/login" replace />}>
            <Route path="/myMarket" element={<MyMarket />} />
            <Route path="/myOS" element={<MyOS />} />
            <Route path="/exportOsData" element={<ExportOsData />} />
            <Route path="/importData" element={<ImportData />} />
            <Route path="/marketDisplay" element={<MarketDisplay />} />
            <Route path="/brouillon" element={<MyOS />} />
            <Route path="/createOS" element={<CreateOS />} />
            <Route path="/userManagement" element={<UserManagement />} />
            <Route path="/newDecompte" element={<NewDecompte />} />
            <Route path="/myDecompte" element={<MyDecompte />} />
            <Route index element={<Navigate to="/myMarket" replace />} />
          </Route>
          <Route path="*" element={<Navigate to={connected ? "/myMarket" : "/login"} replace />} />
        </Routes>
      </MantineProvider>
    </BrowserRouter>
  );
}

function App() {
  return (
    <UserProvider>
      <Routing />
      {/* Add WebSocketComponent here if needed */}
    </UserProvider>
  );
}

export default App;
